import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import type { IdeaBookItem } from "./types";

const GET_IDEA_BOOK_ITEMS = gql`
  query GetIdeaBookItems($ideaBookId: ID!) {
    getIdeaBookItems(ideaBookId: $ideaBookId) {
      _id
      ideaBookId
      homeownerId
      note
      createdAt
      updatedAt
      image {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type GetIdeaBookItemsData = {
  getIdeaBookItems: IdeaBookItem[];
};

type GetIdeaBookItemsVars = {
  ideaBookId: string;
};

export const useGetIdeaBookItems = () => {
  const [getIdeaBookItemsQuery, { loading, error, data }] = useLazyQuery<
    GetIdeaBookItemsData,
    GetIdeaBookItemsVars
  >(GET_IDEA_BOOK_ITEMS);

  const getIdeaBookItems = useCallback(
    async (ideaBookId: string, refresh: boolean = false) => {
      const result = await getIdeaBookItemsQuery({
        variables: { ideaBookId },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result.data?.getIdeaBookItems ?? [];
    },
    [getIdeaBookItemsQuery]
  );

  return {
    getIdeaBookItems,
    loading,
    error,
    ideaBookItems: data?.getIdeaBookItems ?? [],
  };
};
